/**
 * BBIBOLL — Bullish-Bear Bollinger.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLBands.cs, classe
 * FML.BBIBOLL), overlay de preço com 3 linhas:
 *
 *   BBI = (MA(C,3) + MA(C,6) + MA(C,12) + MA(C,24)) / 4   (fixo, = FML.BBI)
 *   UPR = BBI + P·STD(BBI, N)
 *   DWN = BBI − P·STD(BBI, N)
 *
 * MA = média aritmética do engine (silverlightDsl.ma); STD = desvio-padrão
 * AMOSTRAL do engine (silverlightDsl.std, Bessel N/(N-1)) aplicado à SÉRIE BBI.
 * Ordem de operações preservada (P·STD, depois BBI±) para bater bit-a-bit. BBI
 * emite a partir de 23 barras (max período 24); UPR/DWN a partir de 23+(N-1).
 * Paridade provada em __tests__/bbiBoll.silverlight.test.js.
 */
import { getSourcePathAccessor } from "../utils";
import { ma, add, div, std, mul, sub } from "./silverlightDsl";
import { BBIBOLL as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, multiplier, sourcePath } = options;

    const source = getSourcePathAccessor(sourcePath);
    const c = data.map((d, i) => {
      const v = source(d, i);
      return Number.isFinite(v) ? v : NaN;
    });

    // BBI fixo 3/6/12/24 — mesma ordem do engine ((ma3+ma6)+ma12)+ma24)/4.
    const bbi = div(add(add(add(ma(c, 3), ma(c, 6)), ma(c, 12)), ma(c, 24)), 4);
    const band = mul(multiplier, std(bbi, period)); // P·STD(BBI,N)
    const upr = add(bbi, band);
    const dwn = sub(bbi, band);

    // Borda com o chart: NaN → undefined por linha (a média emite antes das bandas).
    return bbi.map((_, i) => {
      const middle = Number.isFinite(bbi[i]) ? bbi[i] : undefined;
      const top = Number.isFinite(upr[i]) ? upr[i] : undefined;
      const bottom = Number.isFinite(dwn[i]) ? dwn[i] : undefined;
      if (middle === undefined && top === undefined && bottom === undefined)
        return undefined;
      return { top, middle, bottom };
    });
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    // BBI warm-up = 23; STD adiciona (period-1). Bandas = 23 + period - 1.
    return Math.max(0, 23 + Math.max(1, period) - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
